enum OrderFinancingTypeEnum
{
    INSTALLMENT = "INSTALLMENT",
    OPERATING_LEASE = "OPERATING_LEASE",
    CONSUMER_LOAN = "CONSUMER_LOAN",
    GOODS_FINANCING = "GOODS_FINANCING",
}

export default OrderFinancingTypeEnum;
